import { injectIntl } from 'react-intl';
import type { WrappedComponentProps } from 'react-intl';

import { BranchInfoDialog } from 'src/components/ref-label';
import urls from 'src/sections/repository/urls';
import {
  getRepoOwnerAvatarUrl,
  getRepoOwnerName,
  getRepoOwnerUrl,
} from 'src/sections/repository/utils/repository-owner';
import { PullRequestRepo } from 'src/types/pull-requests-table';

import { messages } from './pull-request-ref-branch.i18n';

type PullRequestRefBranchProps = WrappedComponentProps & {
  isDifferentRepo?: boolean;
  pullRequestRepo: PullRequestRepo;
};

function PullRequestRefBranch({
  pullRequestRepo,
  isDifferentRepo = false,
  intl,
}: PullRequestRefBranchProps) {
  const branchName = pullRequestRepo.branch.name;
  const { repository } = pullRequestRepo;
  const repoFullName = repository ? repository.full_name : '';
  const [repoBaseUrl, slug] = repoFullName.split('/');

  const deletedRepoMessage = intl.formatMessage(messages.deletedRepository);
  const description = isDifferentRepo
    ? `${repoFullName || deletedRepoMessage}:${branchName}`
    : branchName;

  const repositoryBasedProps = repository
    ? {
        repoName: repository.name,
        repoHref: repository.links.html.href,
        repoAvatarSrc: repository.links.avatar.href,
        repoOwnerAvatarSrc: getRepoOwnerAvatarUrl(repository),
        repoOwnerHref: getRepoOwnerUrl(repository),
        repoOwnerName: getRepoOwnerName(repository),
      }
    : {};

  const branchHref =
    repoBaseUrl && slug && urls.ui.branch(repoBaseUrl, slug, branchName);

  return (
    <BranchInfoDialog
      branchName={branchName}
      branchHref={branchHref}
      description={description}
      {...repositoryBasedProps}
      supportsRetargeting={false}
    />
  );
}

PullRequestRefBranch.defaultProps = { isDifferentRepo: false };

// eslint-disable-next-line import/no-default-export
export default injectIntl(PullRequestRefBranch);
